// Props for the useTipTapEditor hook
export interface UseTipTapEditorProps {
  readOnly?: boolean;
  multiline?: boolean;
  initialContent: string;
  onChange?: (output: string) => Promise<void>;
  onFocus?: () => void;
  onBlur?: (event?: any) => void;
  onError?: (errorMessage: string) => void;
  placeholder?: string;
  slashCommandItems?: any[];
}

// Props for the useBoardNodeTipTapEditor hook
export interface UseBoardNodeTipTapEditorProps {
  boardNodeId: string;
  boardId: string;
}

// State interface for board node editor
export interface EditorState {
  latestContent: string;
  saveInProgress: boolean;
  editorFocused: boolean;
  pendingSave: boolean;
  pendingChanges: boolean;
}

// Type guard for objects with blocks property
export const hasBlocks = (obj: any): obj is { blocks: any[] } => {
  return obj && typeof obj === 'object' && 'blocks' in obj;
};

// Focus handler reference function type
export type FocusHandlerFn = (
  e: React.MouseEvent<HTMLElement, MouseEvent>,
  containerId: string
) => void;

// Editor node refs for focus handling
export interface EditorNodeRefs {
  nodeRef: React.RefObject<HTMLElement>;
  containerId: string;
  focusHandler: FocusHandlerFn;
}
